import { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "@/shared/components/layout/Sidebar";
import { LayoutRoutes } from "@/routes";

function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        // md breakpoint
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden">
      <div
        className={`${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out md:translate-x-0 fixed md:static z-30 h-full`}
      >
        <Sidebar />
      </div>
      <div className="flex-1 overflow-hidden relative w-full">
        <Header onMenuClick={() => setIsSidebarOpen(true)} />
        <div className="h-[calc(100%-57px)] mt-[57px] overflow-y-auto">
          <LayoutRoutes />
        </div>
      </div>
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-20 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}
    </div>
  );
}

export default Layout;
